import { useUser } from '@/stores/authStore';
import { isBorrower } from '@/utils/user';
import { PoolListFilterButton } from './filters/PoolListFilterButton';
import { PoolListTabs } from './PoolListTabs';

type PoolListHeaderProps = {
  tabs: { id: string; label: string }[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
  onShowFilters: () => void;
  onShowDraftPools?: () => void;
  showDraftPools?: boolean;
};

export function PoolListHeader({
  tabs,
  activeTab,
  onTabChange,
  onShowFilters,
  onShowDraftPools,
  showDraftPools = false,
}: PoolListHeaderProps) {
  const user = useUser();
  const isBorrowerUser = isBorrower(user);
  return (
    <div className="w-full flex justify-between items-center gap-4 mb-6">
      <PoolListTabs tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} />
      <div className="flex items-center gap-2">
        <PoolListFilterButton onShowFilters={onShowFilters} />
        {onShowDraftPools && isBorrowerUser && (
          <button
            onClick={onShowDraftPools}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-colors cursor-pointer ${
              showDraftPools ? 'bg-gray-200 text-black' : 'hover:bg-gray-50'
            }`}
          >
            <span className="text-sm font-medium text-black [font-family:var(--ep-font-avenir)]">Draft pools</span>
          </button>
        )}
      </div>
    </div>
  );
}
